import { ValidationIcon_default } from "./chunk-N7RSLTZJ.js";
import { InputComponent } from "./chunk-DBD5CSY6.js";
import { TransitionComponent } from "./chunk-QUQRJRHE.js";
import { Spinner_default } from "./chunk-3P5HEDZF.js";
import { __objRest, __spreadProps, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/elements/Listbox/Listbox.tsx
import { forwardRef, useMemo, Children, Fragment } from "react";
import clsx from "clsx";
import { Listbox as HeadlessListbox, ListboxButton, ListboxOptions } from "@headlessui/react";
import { jsx, jsxs } from "react/jsx-runtime";
var Listbox = forwardRef((_a, ref) => {
  var _b = _a,
    {
      children,
      name,
      value,
      defaultValue,
      onChange,
      disabled,
      validation,
      placeholder,
      isLoading,
      className
    } = _b,
    rest = __objRest(_b, ["children", "name", "value", "defaultValue", "onChange", "disabled", "validation", "placeholder", "isLoading", "className"]);
  const selectedLabel = useMemo(() => {
    const childrenArray = Children.toArray(children);
    const labelChild = childrenArray.find(child => child.props.value === value);
    return (labelChild == null ? void 0 : labelChild.props.children) ? labelChild.props.children : "";
  }, [children, value]);
  return /* @__PURE__ */jsxs(HeadlessListbox, {
    as: "div",
    name,
    value,
    defaultValue,
    onChange,
    disabled,
    className: clsx("pd:listbox-wrapper", className),
    children: [/* @__PURE__ */jsxs(InputComponent, {
      validation,
      disabled,
      className: clsx("pd:h-12 pd:w-full", !selectedLabel && placeholder && "pd:listbox--placeholder", isLoading && "pd:listbox--loading", validation && "pd:listbox--validation"),
      children: [/* @__PURE__ */jsx(InputComponent.Input, __spreadProps(__spreadValues({
        ref,
        as: ListboxButton
      }, rest), {
        isLoading,
        className: "pd:listbox__input",
        children: selectedLabel || placeholder
      })), validation && !isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
        children: /* @__PURE__ */jsx(ValidationIcon_default, {
          variant: validation
        })
      }), isLoading && /* @__PURE__ */jsx(InputComponent.Icon, {
        children: /* @__PURE__ */jsx(Spinner_default, {
          variant: "primary"
        })
      })]
    }), /* @__PURE__ */jsx(TransitionComponent, {
      variant: "appear-from-top",
      as: Fragment,
      children: /* @__PURE__ */jsx(ListboxOptions, {
        static: true,
        className: "pd:absolute pd:top-full pd:z-20 pd:mt-2 pd:max-h-80 pd:w-full pd:overflow-auto pd:rounded-md pd:border pd:bg-white pd:shadow-md pd:outline-hidden",
        children
      })
    })]
  });
});
var Listbox_default = Listbox;
export { Listbox_default };